<template>
    <div>
        <div class="col-12 mb-4 d-sm-flex justify-content-sm-between align-items-sm-baseline">
            <h4>Reports</h4>
        <div class="d-sm-flex col-12 col-sm-auto text-right pr-0 mt-2 mt-sm-0">
            <div class="d-sm-flex">
                <ReportFilters
                        class="d-flex"
                        fill-from-year="2000"
                        :from-year="reportsFrom"
                        :to-year="reportsTo"
                        :loading="loading"
                        :date-type="reportsDateType"
                        @on-from-input="setFilterProps({ dateFrom: $event })"
                        @on-to-input="setFilterProps({ dateTo: $event })"
                        @on-date-type-input="setFilterProps({ dateType: $event })">
                </ReportFilters>
            </div>
        </div>
        </div>

        <div class="card">
            <div class="col-9 d-flex mt-5 mb-5 card-body">
                <AppSelect :value="axisY"
                           :options="axisYList"
                           track-by="value"
                           :disabled="loading"
                           label-field="value"
                           placeholder="Choose one"
                           class="d-flex col-3 mt-4"
                           @input="setFilterProps({ axisY: $event })"/>
                <line-chart :chart-data="chartData"
                            class="col-9"
                            :options="options">
                </line-chart>
                <div class="col-4 mt-4">
                    <AppSelect :value="type"
                               :options="reportTypes"
                               track-by="value"
                               :disabled="loading"
                               label-field="name"
                               placeholder="Select report type"
                               @input="setFilterProps({ type: $event })"/>
                    <div v-if="type" class="mt-4">
                        <AppSelect :value="axisX"
                                   v-if="type"
                                   :allow-empty="true"
                                   :options="entitySuggestions"
                                   track-by="id"
                                   label-field="name"
                                   placeholder="Type name"
                                   @search-change="suggestEntites"
                                   @input="setFilterProps({ axisX: $event })"/>
                        <button class="btn btn-outline-secondary"
                                @click="setFilterProps({ axisX: null })">
                            Clear selected
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import debounce from 'lodash.debounce';
import LineChart from './ReportChart';
import ReportFilters from './ReportFilters';
import AppSelect from '../form/AppSelect';
import formatCurrency from '../../filters/currency.filter';

export default {
  components: {
    AppSelect,
    ReportFilters,
    LineChart,
  },
  filters: {
    currency: formatCurrency,
  },
  computed: {
    ...mapState({
      type: (state) => state.reports.filters.type,
      axisX: (state) => state.reports.filters.axisX,
      axisY: (state) => state.reports.filters.axisY,
      reportsDateType: (state) => state.reports.filters.dateType,
      reportsFrom: (state) => state.reports.filters.dateFrom,
      reportsTo: (state) => state.reports.filters.dateTo,
    }),
  },
  data() {
    return {
      entitySuggestions: [],
      loading: false,
      reportTypes: [
        { name: 'Product type', value: 'product_type' },
        { name: 'Client', value: 'client' },
        { name: 'Region', value: 'region' },
        { name: 'Job location', value: 'job_location' },
      ],
      axisYList: [
        { value: 'Cargo size' },
        { value: 'Kilos used' },
        { value: 'Revenue' },
        { value: 'No of jobs' },
        { value: 'No of sales' },
        { value: 'No of deliveries' },
        { value: 'No of treatments' },
      ],
      chartData: {
        labels: null,
        datasets: null,
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    this.getReports();
  },
  methods: {
    suggestEntites: debounce(function suggest(query) {
      let dispatchEvent = null;
      let entityType = null;
      switch (this.type.value) {
        case 'product_type':
          dispatchEvent = 'productTypes/suggestProductTypes';
          break;
        case 'client':
          dispatchEvent = 'companies/suggestCompanies';
          break;
        case 'region':
          dispatchEvent = 'regions/suggestRegions';
          break;
        case 'job_location':
          dispatchEvent = 'locations/suggestLocations';
          entityType = 'job';
          break;
        default:
          break;
      }
      return this.$store.dispatch(dispatchEvent, { query, type: entityType })
        .then((suggestions) => {
          this.entitySuggestions = suggestions;
        });
    }, 300),
    setFilterProps(filters) {
      // after switching type we should clear selection of axis X to null
      if (filters.hasOwnProperty('type')) {
        filters.axisX = null;
      }

      this.$store.commit('reports/filterProps', filters);
      this.getReports();
    },
    getReports() {
      if (!this.type || !this.axisY || !this.reportsDateType
        || !this.reportsFrom || !this.reportsTo) {
        return;
      }
      this.loading = true;

      this.$store.dispatch('reports/getReports').then((res) => {
        // setting max decimals
        res.chartData.datasets[0].data = res.chartData.datasets[0].data
          .map((dataValue) => dataValue.toFixed(2));
        this.chartData = res.chartData;
      })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
